import { Purse } from '../schema'
import { AwardingMethodCode } from '@/queries/program_purses/schemas'

export type DistributionSummary = {
  heading: string | null
  rows: Array<{
    key: number | string
    label: string
    amount: number
  }>
  message: string | null
}

export function getDistributionSummary(purse: Purse): DistributionSummary {
  const awardingMethod = purse.awarding_method_code
  if (!awardingMethod) {
    return {
      heading: null,
      rows: [],
      message:
        'No awarding method is configured for this purse. Configure a rule before starting the distribution.',
    }
  }

  switch (awardingMethod) {
    case AwardingMethodCode.enum.grade_level:
      return {
        heading: 'Award Amounts by Grade',
        rows:
          purse.grade_distributions?.map((item) => ({
            key: item.id,
            label: item.grade_level_name,
            amount: item.amount,
          })) ?? [],
        message: null,
      }

    case AwardingMethodCode.enum.education_type:
      return {
        heading: 'Award Amounts by Education Type',
        rows:
          purse.education_distributions?.map((item) => ({
            key: item.education_type_id,
            label: item.education_awarding_type_name,
            amount: item.base_amount,
          })) ?? [],
        message: null,
      }

    case AwardingMethodCode.enum.fixed_amount:
      return {
        heading: 'Award Amount per Student',
        rows:
          purse.fixed_distribution?.base_amount != null
            ? [
                {
                  key: purse.fixed_distribution.id,
                  label: purse.awarding_method_name ?? 'Fixed Amount',
                  amount: purse.fixed_distribution.base_amount,
                },
              ]
            : [],
        message: null,
      }
  }
}
